import * as React from 'react';
import { Image, StyleSheet, Text } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import * as AppConstants from "../context/AppConstants";
import * as AppUtilities from "../context/AppUtilities";
import { Explore } from "./Explore";
import { useSelector, useDispatch } from 'react-redux';
import { FilterSlider } from '../components/FilterSlider';
import { ProductDetails } from "./ProductDetails";
import { LocationDetails } from "./LocationDetails";
import { HeaderLeft } from '../components/HeaderLeft';

const styles = StyleSheet.create({
  mainImage: {
    width: 144,
    height: 38,
  },
});

const Stack = createNativeStackNavigator();

export function ExploreStack() {
  const showFilterSlider = useSelector((state) => state.showFilterSlider);

  let mainImage = <Image source={require('../../assets/explore.png')} style={styles.mainImage} />;
  if (AppUtilities.isWeb()) {
    mainImage = <a href="/">{mainImage}</a>;
  }
  
  return (
    <Stack.Navigator
      screenOptions={({ navigation, route }) => ({
        headerRight: AppUtilities.getHeaderRight(navigation),
        headerTitle: (props) => <></>,
        detachPreviousScreen: false,
        animationEnabled: false,
        headerBackVisible: false,
        headerBackTitleVisible: false,
      })}
    >
      <Stack.Screen
        name={AppConstants.SCREENS.EXPLORE}
        component={Explore}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} forceNoBackButton={true}>{mainImage}</HeaderLeft>,
          headerRight: () => showFilterSlider ? <FilterSlider vertical={false} /> : null,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.PRODUCT_EXPLORE_DETAILS}
        component={ProductDetails}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Loading..." noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.PRODUCER_EXPLORE_DETAILS}
        component={LocationDetails}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Loading..." />,
          headerRight: () => showFilterSlider ? <FilterSlider vertical={false} /> : null,
        })}
      />
    </Stack.Navigator>
  );
}
